<script>
	import { LayerCake, Svg, Html } from "layercake";
	import { feature } from "topojson";
	import { geoAlbersUsa } from "d3-geo";
	import { scaleQuantize } from "d3-scale";
	import { format } from "d3-format";
	import MapSvg from "./Map-svg.svelte";
	import Tooltip from "./Tooltip.svelte";
	import usStates from "./us-states-topojson.js";
	import sourceIndex from "./data/source_index.js";

	import total_rev from "./data/total_rev.js";
	import fed_rev from "./data/fed_rev.js";
	import local_rev from "./data/local_rev.js";
	import state_rev from "./data/state_rev.js";
	import all_ins from "./data/all_ins.js";
	import ins_sal from "./data/ins_sal.js";
	import ins_ben from "./data/ins_ben.js";
	import all_supp from "./data/all_supp_NEW.js";
	import supp_sal from "./data/supp_sal.js";
	import supp_ben from "./data/supp_ben.js";
	import supp_f_om from "./data/supp_f_om.js";
	import supp_f_pss from "./data/supp_f_pss.js";
	import supp_f_sa from "./data/supp_f_sa.js";
	import supp_f_is from "./data/supp_f_is.js";
	import supp_f_pt from "./data/supp_f_pt.js";
	import supp_f_oth from "./data/supp_f_oth.js";
	import supp_f_ga from "./data/supp_f_ga.js";
	import capital from "./data/capital.js";
	import debt from "./data/debt.js";
	import enrollment from "./data/enrollment.js";

	import year from "./year.js";
	import {
		LinkedIn,
		Facebook,
		Twitter,
	} from "svelte-share-buttons-component";

	// Social Media Share
	const url = "https://reason.org/commentary/k-12-education-spending-spotlight/";
	const title = "Reason Foundation's K-12 Education Spending Spotlight";

	const colorKey = "% Change";

	/* --------------------------------------------
	 * Create lookups to more easily join our data
	 * `dataJoinKey` is the name of the field in the data
	 * `mapJoinKey` is the name of the field in the map file
	 */
	const dataJoinKey = "name";
	const mapJoinKey = "name";
	const dataLookup = new Map();

	const geojson = feature(usStates, usStates.objects.collection);
	const projection = geoAlbersUsa;

	// 	START: MODIFIED SECTION

	//   import stateData from './us-states-data.js';
	let binCount = 18;
	let output = 0;
	let source = 7;
	let colorRange = [
			"#ffc4a8",
			"#fdaa87",
			"#fca07b",
			"#fc966f",
			"#fa8054",
			"#f75c28",
			"#f43b00"
		];

	$: binCount = binCount;
	$: stateData = total_rev[output][binCount];
	$: {
		source = source;

		if(source == 0) {
			stateData = total_rev[output][binCount];
			colorRange = ["#d3d3d3", "#ffc4a8", "#fca07b", "#fa8054", "#f43b00"];
		} else if (source == 1) {
			stateData = fed_rev[output][binCount];
			colorRange = ["#d3d3d3", "#ffc4a8", "#fca07b", "#fa8054", "#f43b00"];
		} else if (source == 2) {
			stateData = state_rev[output][binCount];
			colorRange = ["#d3d3d3", "#ffc4a8", "#fca07b", "#fa8054", "#f43b00"];
		} else if (source == 3) {
			stateData = local_rev[output][binCount];
			colorRange = ["#d3d3d3", "#ffc4a8", "#fca07b", "#fa8054", "#f43b00"];
		} else if (source == 4) {
			stateData = all_ins[output][binCount];
			colorRange = ["#d3d3d3", "#d8e5f2",  "#a4beda", "#7098c3", "#3973ac"];
		} else if (source == 5) {
			stateData = ins_sal[output][binCount];
			colorRange = ["#d3d3d3", "#d8e5f2",  "#a4beda", "#7098c3", "#3973ac"];
		} else if (source == 6) {
			stateData = ins_ben[output][binCount];
			colorRange = ["#d3d3d3", "#d8e5f2",  "#a4beda", "#7098c3", "#3973ac"];
		} else if (source == 7) {
			stateData = all_supp[output][binCount];
			colorRange = ["#d3d3d3", "#fdefd2",  "#f4d395", "#eab659", "#e0980b"];
		} else if (source == 8) {
			stateData = supp_sal[output][binCount];
			colorRange = ["#d3d3d3", "#fdefd2",  "#f4d395", "#eab659", "#e0980b"];
		} else if (source == 9) {
			stateData = supp_ben[output][binCount];
			colorRange = ["#d3d3d3", "#fdefd2",  "#f4d395", "#eab659", "#e0980b"];
		} else if (source == 10) {
			stateData = supp_f_om[output][binCount];
			colorRange = ["#d3d3d3", "#e0ecf9", "#9fb7d4",  "#6183af", "#1b538b"];
		} else if (source == 11) {
			stateData = supp_f_pss[output][binCount];
			colorRange = ["#d3d3d3", "#e0ecf9", "#9fb7d4",  "#6183af", "#1b538b"];
		} else if (source == 12) {
			stateData = supp_f_sa[output][binCount];
			colorRange = ["#d3d3d3", "#e0ecf9", "#9fb7d4",  "#6183af", "#1b538b"];
		} else if (source == 13) {
			stateData = supp_f_is[output][binCount];
			colorRange = ["#d3d3d3", "#e0ecf9", "#9fb7d4",  "#6183af", "#1b538b"];
		} else if (source == 14) {
			stateData = supp_f_pt[output][binCount];
			colorRange = ["#d3d3d3", "#e0ecf9", "#9fb7d4",  "#6183af", "#1b538b"];
		} else if (source == 15) {
			stateData = supp_f_oth[output][binCount];
			colorRange = ["#d3d3d3", "#e0ecf9", "#9fb7d4",  "#6183af", "#1b538b"];
		} else if (source == 16) {
			stateData = supp_f_ga[output][binCount];
			colorRange = ["#d3d3d3", "#e0ecf9", "#9fb7d4",  "#6183af", "#1b538b"];
		} else if (source == 17) {
			stateData = capital[output][binCount];
			colorRange = ["#d3d3d3", "#cad1dc",  "#929aa6", "#5e6674", "#2e3745"];
		} else if (source == 18) {
			stateData = debt[output][binCount];
			colorRange = ["#d3d3d3", "#ffc4a8", "#fca07b", "#fa8054", "#f43b00"];
		} else {
			stateData = enrollment[output][binCount];
			colorRange = ["#d73027", "#fdae61", "#d9ef8b", "#66bd63"];
		}
	};

	let z_domain = [-0.25, 1];

	$: {
		source = source;

		if (source === 19) {
			z_domain = [-0.20, 0.20];

		} else {
		if(output == 0) {
			z_domain = [-0.25, 1];
		} else if (output == 1) {
			z_domain = [-0.25, 1];
		} else if (output == 2) {
			z_domain = [-0.5, 2];
		} else {
			z_domain = [-0.5, 2];
		}
	}
	}

	$: stateData.forEach((d) => {
		dataLookup.set(d[dataJoinKey], d);
		dataLookup = dataLookup;
	});
	$: console.log(year[binCount]["Year"]);
	// 	END: MODIFIED SECTION

	let evt;
	let hideTooltip = true;

	// Create a flat array of objects that LayerCake can use to measure
	// extents for the color scale
	const flatData = geojson.features.map((d) => d.properties);

	const addCommas = format(",");

	let count = 18;
	let countPlus = 18;

	function valuePlus() {
		binCount += 1;
	}

	function valueMinus() {
		binCount -= 1;
	}

	$: {
		binCount = Math.min(Math.max(binCount % 19, 0), 19);
	}
</script>

<div class="chart-container">
	<div class="social-media">
		<Facebook class="share-button" quote={title} {url} /> <br />
		<LinkedIn class="share-button" {url} /> <br />
		<Twitter class="share-button" text={title} {url} via="ReasonFdn" />
	</div>

	<div class="row">
		<div class="column1">
			</div>
		<div class="column2">
			<select bind:value={output}>
				<option value={0}>Per Pupil (inflation adjusted)</option>
				<option value={1}>Total (inflation adjusted)</option>
				<option value={2}>Per Pupil</option>
				<option value={3}>Total</option>
			  </select>
		</div>
		<div style="text-align: center; font-size: 11px; position: absolute; top: 3%; right: 30%;">
			<button class="arrow-button" on:click={valueMinus}>
				<div class="left-arrow">&#10148;</div>
			</button>
			<button class="arrow-button" on:click={valuePlus}>
				<div class="right-arrow">&#10148;</div>
			</button>
		</div>
		<div style="margin-top: 10px; font-size: 11px;">
			<span style="position: absolute; top: 2%; right: 26%;">2002</span>
			<span style="position: absolute; top: 2%; right: 9%;">2020</span>
			<input
				class="range-style"
				style = "position: absolute; top: 2%; right: 9%; width: 20%;"
				type="range"
				min="0"
				max="18"
				step="1"
				bind:value={binCount}
			/>
		</div>
	</div>
	<div class="row">
		<span style="margin: 0 10px 10px 10px; display:inline-block; font-size: 22px; font-weight: 700;">
			K-12 {sourceIndex[source].source} Growth (2002 - 
		<span style="font-size: 22px;">
			{year[binCount]["Year"]})
		</span>
	</div>

	{#if source === 19}
	<div id="chart-legend" class="panel-body">
		<div class="legend-value">
			<div class="legend-block" style="background-color: {colorRange[3]};" />
			>10%
		</div>
		<div class="legend-value">
			<div class="legend-block" style="background-color: {colorRange[2]};" />
			0%-10%
		</div>
		<div class="legend-value">
			<div class="legend-block" style="background-color: {colorRange[1]};" />
			-10%-0%
		</div>
		<div class="legend-value">
			<div class="legend-block" style="background-color: {colorRange[0]};" />
			&lt; -10%
		</div>
	</div>
	{:else if output === 0 || output === 1}
	<div id="chart-legend" class="panel-body">
		<div class="legend-value">
			<div class="legend-block" style="background-color: {colorRange[4]};" />
			>75%
		</div>
		<div class="legend-value">
			<div class="legend-block" style="background-color: {colorRange[3]};" />
			50%-75%
		</div>
		<div class="legend-value">
			<div class="legend-block" style="background-color: {colorRange[2]};" />
			25%-50%
		</div>
		<div class="legend-value">
			<div class="legend-block" style="background-color: {colorRange[1]};" />
			0%-25%
		</div>
		<div class="legend-value">
			<div class="legend-block" style="background-color: {colorRange[0]};" />
			&lt;0%
		</div>
	</div>
	{:else}
	<div id="chart-legend" class="panel-body">
		<div class="legend-value">
			<div class="legend-block" style="background-color: {colorRange[4]};" />
			>150%
		</div>
		<div class="legend-value">
			<div class="legend-block" style="background-color: {colorRange[3]};" />
			100%-150%
		</div>
		<div class="legend-value">
			<div class="legend-block" style="background-color: {colorRange[2]};" />
			50%-100%
		</div>
		<div class="legend-value">
			<div class="legend-block" style="background-color: {colorRange[1]};" />
			0%-50%
		</div>
		<div class="legend-value">
			<div class="legend-block" style="background-color: {colorRange[0]};" />
			&lt;0%
		</div>
	</div>
	{/if}

	<!-- <div class="input-container" style="display:inline-block; position: absolute;right:10px;z-index: 9;"></div> -->
	<LayerCake
		data={geojson}
		z={(d) => dataLookup.get(d[mapJoinKey])[colorKey]}
		zScale={scaleQuantize()}
		zRange={colorRange}
		zDomain={z_domain}
		{flatData}
	>
		<Svg>
			<MapSvg
				{projection}
				on:mousemove={(event) => (evt = hideTooltip = event)}
				on:mouseout={() => (hideTooltip = true)}
			/>
		</Svg>

		<Html pointerEvents={false}>
			{#if source !== 19 && hideTooltip !== true}
				<Tooltip {evt} let:detail>
					<!-- For the tooltip, do another data join because the hover event only has the data from the geography data -->
					{@const tooltipData = {
						...detail.props,
						...dataLookup.get(detail.props[mapJoinKey]),
					}}
					<div class="row" style="font-size: 16px; font-weight: 700; margin: 0;">
						{tooltipData["name"]}
					</div>
					<hr style="border-top: 3px solid #d3d3d3; margin: 2px;" />
					<span style="font-size: 11px; font-weight: 600;">
						% Change:
					</span>
					<span style="font-size: 18px; font-weight: 800;">
						{Math.round(tooltipData["% Change"] * 100)}%
					</span>
					<hr style="border-top: 1px solid #d3d3d3; margin: 2px;">
					<span style="font-size: 12px;">
					{year[binCount]["Year"]}: ${addCommas(Math.round(tooltipData["Selected Year"]))}
					<br>
					2002: ${addCommas(Math.round(tooltipData["2002"]))}
					</span>
				</Tooltip>
				{:else if hideTooltip !== true}
				<Tooltip {evt} let:detail>
					<!-- For the tooltip, do another data join because the hover event only has the data from the geography data -->
					{@const tooltipData = {
						...detail.props,
						...dataLookup.get(detail.props[mapJoinKey]),
					}}
					<div class="row" style="font-size: 16px; font-weight: 700; margin: 0;">
						{tooltipData["name"]}
					</div>
					<hr style="border-top: 3px solid #d3d3d3; margin: 2px;" />
					<span style="font-size: 11px; font-weight: 600;">
						% Change:
					</span>
					<span style="font-size: 18px; font-weight: 800;">
						{Math.round(tooltipData["% Change"] * 1000) / 10}%
					</span>
					<hr style="border-top: 1px solid #d3d3d3; margin: 2px;">
					<span style="font-size: 12px;">
					{year[binCount]["Year"]}: {addCommas(Math.round(tooltipData["Selected Year"]))}
					<br>
					2002: {addCommas(Math.round(tooltipData["2002"]))}
					</span>
				</Tooltip>
			{/if}
		</Html>
	</LayerCake>
	<span class="footnote">
		Source: 
		<a href="https://reason.org/topics/education/" target="_blank">
			Reason Foundation
		</a>
		&#183;
		<a href="https://ss2-map-support-services.vercel.app/" target="_blank">
			Link for Embed
		</a>
	</span>
</div>

<style>
	/*
		The wrapper div needs to have an explicit width and height in CSS.
		It can also be a flexbox child or CSS grid element.
		The point being it needs dimensions since the <LayerCake> element will
		expand to fill it.
	*/
	.chart-container {
		width: 92%;
		height: 75%;
	}

	.footnote {
		font-size: 11px;
	}

	a {
		color: #f63;
	}

	select {
        width: 200px;
        margin: 10px;
    }

	.column1 {
		float: left;
		width: 210px;
		font-size: 14px;
		margin-top: -10px;
	}

	.column2 {
		float: left;
		width: 210px;
		font-size: 14px;
		margin-top: -10px;
	}

	.row:after {
		content: "";
		display: table;
		clear: both;
	}

	.social-media {
		position: absolute;
		top: 10px;
		right: 1%;
	}

	#chart-legend {
		position: absolute;
		top: 70%;
		right: 1%;
		width: 120px;
		padding: 10px;
		font-size: 13px;
		z-index: 99;
	}

	.legend-value {
		margin-bottom: 4px;
	}

	.legend-block {
		width: 20px;
		height: 20px;
		float: left;
		margin-right: 10px;
		background-color: #d3d3d3;
		margin-top: -2px;
	}

</style>
